export type ThemeName = 'blue' | 'gray' | 'light'

export const THEME_STORAGE_KEY = 'qh.theme'

export const THEME_OPTIONS: Array<{
  value: ThemeName
  label: string
  description: string
}> = [
  { value: 'blue', label: '蓝色', description: '默认深蓝交易终端' },
  { value: 'gray', label: '灰色', description: '低饱和中性灰' },
  { value: 'light', label: '浅色', description: '明亮高对比界面' }
]

export function readTheme(): ThemeName {
  const stored = localStorage.getItem(THEME_STORAGE_KEY)
  return stored === 'gray' || stored === 'light' ? stored : 'blue'
}

export function applyTheme(theme: ThemeName): void {
  document.documentElement.dataset.theme = theme
  localStorage.setItem(THEME_STORAGE_KEY, theme)
  window.dispatchEvent(new CustomEvent('qh-theme-change', { detail: theme }))
}

export function initializeTheme(): void {
  document.documentElement.dataset.theme = readTheme()
}
